var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-app-bar',{attrs:{"flat":"","color":"white"}},[_c('div',{staticClass:"pa-2"},[_c('information-dialog-component',{ref:"refDialogComponent",on:{"updated":_vm.updated}})],1),_c('v-spacer')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }